import type { DashboardTask } from "@dune/types";
import { Calendar, CalendarX, CheckCircle2, CircleAlert } from "lucide-react";

interface TaskStatusIconProps {
	task: Pick<DashboardTask, "status" | "dueDate" | "completedAt">;
	className?: string;
	showTooltip?: boolean;
}

export const TaskStatusIcon: React.FC<TaskStatusIconProps> = ({
	task,
	className = "h-4 w-4",
	showTooltip = true,
}) => {
	const getIconData = () => {
		if (task.status === "DONE") {
			if (
				task.dueDate &&
				task.completedAt &&
				new Date(task.completedAt) > new Date(task.dueDate)
			) {
				return {
					icon: CircleAlert,
					colorClass: "text-orange-500",
					title: "Terminée en retard",
				};
			}
			return {
				icon: CheckCircle2,
				colorClass: "text-green-500",
				title: "Terminée",
			};
		}

		if (task.dueDate) {
			if (new Date(task.dueDate) < new Date()) {
				return {
					icon: CalendarX,
					colorClass: "text-red-500",
					title: "Échéance dépassée",
				};
			}
			return {
				icon: Calendar,
				colorClass: "text-blue-500",
				title: "Échéance à venir",
			};
		}

		return {
			icon: Calendar,
			colorClass: "text-gray-400",
			title: "Pas d'échéance",
		};
	};

	const { icon: Icon, colorClass, title } = getIconData();

	if (showTooltip) {
		return (
			<div title={title}>
				<Icon className={`${className} ${colorClass} flex-shrink-0`} />
			</div>
		);
	}

	return <Icon className={`${className} ${colorClass} flex-shrink-0`} />;
};
